import { render } from "./VabeneRestaurantListPage.vue?vue&type=template&id=45fe50e0&ts=true"
import script from "./VabeneRestaurantListPage.vue?vue&type=script&lang=ts"
export * from "./VabeneRestaurantListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__